// export const BUG_ADDED = "bugAdded"

// then when using in other places: actions.BUG_ADDED

export const GET_FOLLOWED_EVENTS = "getFollowedEvents"
export const GET_OWN_EVENTS = "getOwnEvents"
export const GET_ALL_EVENTS = "getAllEvents"
export const GET_FOLLOWED_USERS = "getFollowedUsers"
export const GET_ALL_USERS = "getAllUsers"
export const LOG_IN = "logIn"
export const LOG_OUT = "logOut"
export const SIGN_UP = "signUp"
export const SET_CURRENT_USER = "setCurrentUser"
export const ADD_FOLLOWER = "addFollower"
export const ADD_EVENT = "addEvent"
export const DELETE_FOLLOW = "deleteFollow"
export const DELETE_EVENT = "deleteEvent"
export const UPDATE_EVENT = "updateEvent"
export const ADD_ITEM = "addItem"
export const ALL_ITEMS = "allItems"
export const DELETE_ITEM = "deleteItem"
export const UPDATE_ITEM = "updateItem"
export const UPDATE_USER = "updateUser"

